import { Container, Grid, Text, Title, Card, Group, Badge, Stack, Loader, Alert, Center } from '@mantine/core';
import { useStorageContext } from '@/contexts/StorageContext';
import { ServiceCard } from './ListPage.styles';
import { useEffect, useState } from 'react';
import { IconAlertCircle, IconCalendar, IconUser, IconPhone, IconMail, IconCar, IconBuilding } from '@tabler/icons-react';

export function ListPage() {
  const storageContext = useStorageContext();

  const pto = storageContext.ptoName;
  const apiUrl = storageContext.apiUrl;
  const [list, setList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const getTimestamp = (st: string) => {
    const ar = st.split(" ");
    const td = ar[0].split(".");
    const time = new Date(
      parseInt(td[2]), 
      parseInt(td[1]) - 1, 
      parseInt(td[0]), 
      parseInt(ar[1].split(":")[0]), 
      parseInt(ar[1].split(":")[1])
    ).getTime();
    return time;
  };

  const getList = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await fetch(apiUrl + "/singups/list", {
        method: "GET",
        mode: "cors",
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const respData = await response.json();
      
      // Сортируем по дате (новые сверху)
      respData.sort(function (a: any, b: any) {
        const timestampA = getTimestamp(a.datetime);
        const timestampB = getTimestamp(b.datetime);
        return timestampB - timestampA;
      });
      
      setList(respData);
    } catch (error) {
      console.error('Error fetching list:', error);
      setError('Ошибка загрузки данных. Попробуйте позже.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  const formatDateTime = (datetime: string) => {
    const [date, time] = datetime.split(' ');
    const [day, month, year] = date.split('.');
    return `${day}.${month}.${year} в ${time}`;
  };

  const getTypeFaceLabel = (typeface: string) => {
    return typeface === "1" ? 'Физическое лицо' : 'Юридическое лицо';
  };

  if (loading) {
    return (
      <Container size="xl" py="xl">
        <Center>
          <Stack align="center" gap="md">
            <Loader size="lg" />
            <Text>Загрузка записей...</Text>
          </Stack>
        </Center>
      </Container>
    );
  }

  if (error) {
    return (
      <Container size="xl" py="xl">
        <Alert icon={<IconAlertCircle size={16} />} title="Ошибка" color="red">
          {error}
        </Alert>
      </Container>
    );
  }

  const filteredList = list.filter((item: any) => item.pto === pto);

  return (
    <Container size="xl" py="xl">
      <Title order={1} mb="xl" ta="center">
        Список записей на техосмотр
      </Title>
      
      <Text size="lg" mb="xl" ta="center" c="dimmed">
        Все записи для ПТО: {pto}
      </Text>

      {filteredList.length === 0 ? (
        <Card shadow="sm" padding="lg" radius="md" withBorder>
          <Text ta="center" c="dimmed" size="lg">
            Записи не найдены
          </Text>
        </Card>
      ) : (
        <Grid>
          {filteredList.map((item: any, index: number) => (
            <Grid.Col key={index} span={{ base: 12, md: 6, lg: 4 }}>
              <ServiceCard>
                <Stack gap="md">
                  <Group justify="space-between">
                    <Badge color="blue" leftSection={<IconCalendar size={12} />}>
                      {formatDateTime(item.datetime)}
                    </Badge>
                    <Badge color={item.typeface === "1" ? "green" : "orange"}>
                      {getTypeFaceLabel(item.typeface)}
                    </Badge>
                  </Group>

                  <Group gap="xs">
                    <IconUser size={16} />
                    <Text fw={500}>{item.fio}</Text>
                  </Group>

                  <Group gap="xs">
                    <IconPhone size={16} />
                    <Text>{item.phone}</Text>
                  </Group>

                  <Group gap="xs">
                    <IconMail size={16} />
                    <Text>{item.email}</Text>
                  </Group>

                  <Group gap="xs">
                    <IconCar size={16} />
                    <Text>Тип ТС: {item.typets}</Text>
                  </Group>

                  {item.firm && item.firm !== "" && (
                    <>
                      <Group gap="xs">
                        <IconBuilding size={16} />
                        <Text>Организация: {item.firm}</Text>
                      </Group>
                      {item.inn && (
                        <Text size="sm" c="dimmed">
                          ИНН: {item.inn}
                        </Text>
                      )}
                    </>
                  )}

                  {item.model && (
                    <Text size="lg" >
                      Рег. знак: {item.model}
                    </Text>
                  )}
                </Stack>
              </ServiceCard>
            </Grid.Col>
          ))}
        </Grid>
      )}
    </Container>
  );
}